export default {
  updateList: '/sys/update/list', // 更新列表
  addUpdate: '/sys/update/addorupdate', // 新增功能更新
  functionDetail: '/sys/update/detail/{id}', // 功能详情
  updateStatus: '/sys/update/update', // 更新状态 
};
